import * as Sentry from '@sentry/react'
import { authSelectors } from 'ducks/auth'
import { orgSelectors } from 'ducks/orgs'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { projectInfoSelector } from 'reducer/project/projectInfoReducer'

/**
 * This hook decorates sentry errors with useful information from redux.
 * - Org ID
 * - Org name
 * - Org country
 * - User ID
 * - User Email
 * - Role ID
 * - Role is admin
 * - Role permissions role title
 * - Project ID
 * - Project Country
 */
export const useSentryReduxInfo = () => {
  const user = useSelector(authSelectors.getCurrentUser)
  const role = useSelector(authSelectors.getCurrentRole)
  const org = useSelector(orgSelectors.getOrg)
  const projectId = useSelector(projectInfoSelector.getProjectId)
  const projectCountry = useSelector(projectInfoSelector.getProjectCountryIso2)

  useEffect(() => {
    if (user) {
      Sentry.setUser({
        id: user.id,
        email: user.email,
      })
    } else {
      Sentry.setUser(null)
    }
  }, [user])

  useEffect(() => {
    if (role) {
      Sentry.setTag('role.id', role.id)
      Sentry.setTag('role.is_admin', role.is_admin)
      Sentry.setTag('role.permissions_role_title', role.permissions_role_title)
    } else {
      Sentry.setTag('role.id', undefined)
      Sentry.setTag('role.name', undefined)
    }
  }, [role])

  useEffect(() => {
    if (org) {
      Sentry.setTag('org.id', org.id)
      Sentry.setTag('org.name', org.name)
      Sentry.setTag('org.country', org.country?.iso2)
    } else {
      Sentry.setTag('org.id', undefined)
      Sentry.setTag('org.name', undefined)
      Sentry.setTag('org.country', undefined)
    }
  }, [org])

  useEffect(() => {
    if (projectId) {
      Sentry.setTag('project.id', projectId)
      Sentry.setTag('project.country', projectCountry)
    } else {
      Sentry.setTag('project.id', undefined)
      Sentry.setTag('project.country', undefined)
    }
  }, [projectId, projectCountry])
}
